"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateMapper = templateMapper;
const serviceSchemaMapper_1 = require("./serviceSchemaMapper");
const uiSchemaMapper_1 = require("./uiSchemaMapper");
function templateMapper(template, additionalData) {
    const { organizationUser, chatInfo } = additionalData;
    const services = organizationUser === null || organizationUser === void 0 ? void 0 : organizationUser.getDepartments();
    if (services && chatInfo) {
        const serviceFrequencies = [
            { service: "HHA", title: "Frequency For Aide", key: "frequencyForAide" },
        ];
        (0, serviceSchemaMapper_1.servicesSchemaMapper)(template, services, serviceFrequencies);
        (0, uiSchemaMapper_1.servicesUISchemaMapper)(template, services, serviceFrequencies);
    }
    return template;
}
